interface StepProps {
	name: string;
	children: React.ReactNode;
	description?: string;
	enabled: boolean;
	nextLabel?: string;
	readOnly?: boolean;
	/** Optional override for the circle number rendered in StepperHeader. When absent, renders `index + 1`. */
	displayNumberOverride?: number | string;
	onBeforeNext?: () => Promise<boolean> | boolean;
}

/**
 * Descriptor component for a single step in a StepContainer.
 * StepContainer reads props from this component to build the header.
 * The children are rendered when this step is active.
 */
export const Step: React.FC<StepProps> = ({ children }) => {
	return <>{children}</>;
};

export type { StepProps };
